import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import KnowledgeEnrichmentEscalationReviewsAPI from '../../api/knowledgeEnrichmentEscalationReviews';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  meta: { totalCount: 0, page: 1 },
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getEscalationReviews($state) {
    return $state.records;
  },
  getMeta($state) {
    return $state.meta;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  index: async ({ commit }, { agentBotId, ...params }) => {
    commit(types.SET_KE_ESCALATION_REVIEW_UI_FLAG, { isFetching: true });
    try {
      const response = await KnowledgeEnrichmentEscalationReviewsAPI.index(
        agentBotId,
        params
      );
      commit(types.SET_KE_ESCALATION_REVIEWS, response.data.payload);
      commit(types.SET_KE_ESCALATION_REVIEWS_META, response.data.meta);
      return response.data.payload;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_KE_ESCALATION_REVIEW_UI_FLAG, { isFetching: false });
    }
  },

  dismiss: async ({ commit }, { agentBotId, id }) => {
    commit(types.SET_KE_ESCALATION_REVIEW_UI_FLAG, { isUpdating: true });
    try {
      await KnowledgeEnrichmentEscalationReviewsAPI.dismiss(agentBotId, id);
      commit(types.DELETE_KE_ESCALATION_REVIEW, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_KE_ESCALATION_REVIEW_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_KE_ESCALATION_REVIEW_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_KE_ESCALATION_REVIEWS]: MutationHelpers.set,
  [types.SET_KE_ESCALATION_REVIEWS_META]($state, meta) {
    $state.meta = {
      totalCount: meta.total_count,
      page: meta.page,
    };
  },
  [types.DELETE_KE_ESCALATION_REVIEW]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
